var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eft-payment-details"},[_c('InfoBanner',{staticClass:"mb-4",attrs:{"label":"Payment Reference","value":_vm.paymentReference,"copyable":"","copy-value":_vm.paymentReference,"success-message":"Reference copied to clipboard"}}),_c('BankDetails',{attrs:{"show-notice":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }